import React, {useState} from 'react';
import close from "../../../images/close.svg";
import SendBlock from "../SendBlock/SendBlock";
import {Field, Formik} from "formik";
import {CustomCheckBox} from "../../main/logbook/EditTable";
import {useTheme} from "../../../App";
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";

const SendLicenses = ({closeModal, sendItem, ...props}) => {
  console.log(props.licenses)
  const [emails, setEmails] = useState([])
  const {t} = useTranslation()
  const {isDark} = useTheme()
  return (
    <div style={{width: 572}} className={`modal ${isDark && 'modal__dark'}`}>
      <button onClick={closeModal} className="modal__close">
        <img src={close} alt=""/>
      </button>
      <h5
        className="modal__title mr-30">{sendItem === null ? t('sendLicenses') : `${t('sendLicense')} ${sendItem.name}`}</h5>
      <Formik
        initialValues={{
          message: '',
          selectedLicenses: [],
          isAttachResume: false
        }}
      >
        {({values, handleChange, handleSubmit, ...formikProps}) => {
          return <>
            <div className="modal__sections">
              {sendItem === null && <div className="modal__section pb-0 mb-20">
                <p className="modal__caption mb-20">{t('selectLicenseToSend')}:</p>
                {props.licences?.map((lic, index) => <CustomCheckBox isDark={isDark} key={index}
                                                                    isChecked={values.selectedLicenses.indexOf(lic.id) !== -1}
                                                                    onClick={() => {
                                                                      if (values.selectedLicenses.indexOf(lic.id) !== -1) {
                                                                        formikProps.setFieldValue('selectedLicenses', [...values.selectedLicenses].filter(s => s !== lic.id))
                                                                      } else {
                                                                        formikProps.setFieldValue('selectedLicenses', [...values.selectedLicenses, lic.id])
                                                                      }
                                                                    }}
                                                                    caption={`${lic.license_system?.name}, ${lic.license_type?.name}, ${lic.license_number}, ${lic.issue_date}`}
                                                                    color={'#252526'}
                                                                    fontFamily={'Lato400'}/>)}
              </div>}
              <div className="modal__section pb-0 mb-20">
                <CustomCheckBox isDark={isDark} isChecked={values.isAttach}
                                onClick={() => formikProps.setFieldValue('isAttach', !values.isAttach)}
                                caption={t('attachSailResume')} fontFamily={'Lato400'} color={'#252526'}/>
              </div>
              <div className="modal__section">
                <SendBlock emails={emails} setEmails={setEmails}/>
              </div>
              <div className="modal__section">
                <p className="modal__caption mb-12">{t('messageToRecepient')}:</p>
                <div className="modal__textareaItem w-100 mt-0">
                  <Field component={'textarea'} id={'message'} value={values.message} onChange={handleChange}
                         placeholder={t('messageToRecepientLicenseHolder')}
                         autoComplete={'off'}
                         className="modal__textarea w-100 m-0"/>
                </div>
              </div>
            </div>
            <div className="modal__buttons">
              <div className="modal__actions">
                <button onClick={closeModal} className="submit-button">
                  {t('send')}
                </button>
                <button onClick={closeModal} className={`commonBtn ${isDark && 'commonBtn__dark'}`}>
                  <span className="commonBtn__label">{t('cancel')}</span>
                </button>
              </div>
            </div>
          </>
        }}
      </Formik>
    </div>
  );
};

const mapStateToProps = (state) => ({
  licences: state.profileReducer.licenses
})

export default connect(mapStateToProps, {})(React.memo(SendLicenses))
